import React from "react";
type SectionHeadingProps = {
  eyebrow: string;
  title: string;
  onDark?: boolean;
};
export function SectionHeading({
  eyebrow,
  title,
  onDark = false
}: SectionHeadingProps) {
  return <header className="mx-auto max-w-3xl text-center" data-id="element-66" data-mp="3f1ltpmxn3u64">
      <p className={`font-display text-sm font-extrabold uppercase tracking-wide md:text-base ${onDark ? "text-gold" : "text-brand"}`} data-id="element-67" data-mp="3f2x0lvmdti1g">
        {eyebrow}
      </p>
      <h2 className={`mt-3 text-balance font-display text-[28px] font-black uppercase leading-[1.1] md:text-5xl ${onDark ? "text-white" : "text-ink"}`} data-id="element-68" data-mp="bl588g4c2w2q">
        {title}
      </h2>
    </header>;
}